import React from "react";
import { Flex, Spinner } from "@chakra-ui/react";

const Preloader = ({ ...props }) => (
  <Flex
    alignItems="center"
    justifyContent="center"
    height="inherit"
    minHeight="inherit"
    maxHeight="inherit"
  >
    <Spinner color="brand.primary" size="xl" thickness="3px" {...props} />
  </Flex>
);

export default Preloader;
